export var APP_NAME = "reactivepad";

var PluginKey = require("prosemirror-state").PluginKey;

export var PLUGIN_NAME = APP_NAME + "_prosemirror";
export var pluginKey = new PluginKey(PLUGIN_NAME); // ToDo: is it safe when plugin loaded multiple times on a page?

export var TRANSACTION_METAS = {
  nodeSnapshot: APP_NAME + "_node_snapshot"
};